<button
  [class]="['btn', buttonThemeCssClass, buttonSizeCssClass]"
  [disabled]="isLoading"
  [wlAutomationId]="automationId"
  (click)="buttonClick.emit($event)"
>
  @if (isLoading) {
    <fa-icon
      size="lg"
      icon="spinner-third"
      animation="spin"
      wlAutomationId="spinner-icon"
    ></fa-icon>
  }
  <div [class]="spinnerVisibility">
    <ng-content></ng-content>
  </div>
</button>
